// The API and player share the same tab contract and validation.
export * from '@charlava-com/jamcam-svc';
